const moment = require("moment");
import Swal from "sweetalert2/dist/sweetalert2.js";

if (window.location.pathname.includes("reports/status")) {
  var index = $(".date-select").index($(".date-select.active"));

  $(".date-slider").slick({
    prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
    initialSlide: index,
    infinite: false
  });

  $(function() {
    window.app_data.setup.currentDate = $(".slick-active .date-select").data("date");
  });

  $(".date-slider").on("beforeChange", function(e, slick, currentSlide, nextSlide) {
    var slide = $(slick.$slides[nextSlide]);
    window.app_data.setup.date = window.moment(slide.find(".date-select").data("date"), "MM/DD/YYYY").format("MM/DD/YYYY");
    window.app_data.setup.currentDate = window.app_data.setup.date;
  });

  function formatDate(dateObj) {
    return dateObj ? moment(dateObj).format("MM/DD/YYYY") : null;
  }

  // Button action
  $("body").on("click", ".btn-action", function() {
    const data = $(this).data("value");
    data.locked = $(this).data("locked");
    const defaultDate = $(this).data("default-date");
    const activeDate = $(".slick-active .date-select").data("date");
    const datatables = window.app_data.datatables;

    Swal.fire({
      title: "Status Report Action",
      html: `<div id="statusAction">
        <v-status-report
          :data="data"
          :datatables="datatables"
          :default-date="defaultDate"
          :active-date="activeDate"
        ></v-status-report>
      </div>`,
      icon: undefined,
      showCancelButton: true,
      confirmButtonColor: "#50C3CA",
      showConfirmButton: !data.locked,
      confirmButtonText: data.id === null ? "Submit" : "Update",
      showLoaderOnConfirm: true,
      cancelButtonText: data.locked ? "Close" : "Cancel",
      reverseButtons: true,
      heightAuto: false,
      width: 1024,
      allowOutsideClick: () => !Swal.isLoading(),
      allowEscapeKey: () => !!Swal.isLoading(),
      allowEnterKey: () => !Swal.isLoading(),
      onRender: () => {
        new Vue({
          el: `#statusAction`,
          data: { data: { ...data }, defaultDate, activeDate, datatables }
        });
      },
      preConfirm: async () => {
        if (data.locked) return;

        let jsonData = $("#statusForm").serializeArray();
        try {
          let result = await confirmUpdate(jsonData, $(this));
          return result;
        } catch (e) {
          Swal.showValidationMessage(`There is something wrong!`);
        }
      },
      onClose: () => {
        $('#statusForm input[name="color_code"]').val("");
        $("#statusForm").off("click", ".colorpicker");
        $(".colorpicker-palette").off("click", ".colorpicker-wrapper");
        $(".colorpicker-palette").hide();
      }
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire("Updated", "The placement status data has updated.", "success");
      }
    });
  });

  // Button track
  $("body").on("click", ".btn-tracking", function() {
    $(".table-trackings-tables").slideToggle();
  });

  function confirmUpdate(data, $this) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/placement_status/create",
        method: "POST",
        data: data,
        dataType: "json",
        success: function(response) {
          const status = response["updated"] || response["placement_status"];
          if (!status) return resolve(response);

          window.app_data.data = window.app_data.data.map(item => {
            if (item.id == status["id"]) {
              item["paid_at"] = status["paid_at"];
              item["invoiced_at"] = status["invoiced_at"];
              item["pay_amount"] = status["pay_amount"];
              item["invoice_amount"] = status["invoice_amount"];
              item["prepaid_through"] = formatDate(status["prepaid_through"]);
              item["paid_start_date"] = formatDate(status["paid_start_date"]);
              item["paid_end_date"] = formatDate(status["paid_end_date"]);
              item["paid_notes"] = status["paid_notes"];
              item["invoiced_notes"] = status["invoiced_notes"];
              item["invoiced_start_date"] = formatDate(status["invoiced_start_date"]);
              item["invoiced_end_date"] = formatDate(status["invoiced_end_date"]);
              item["color_code"] = status["color_code"];
              item["insurance_approved_extension_date"] = formatDate(status["insurance_approved_extension_date"]);
              item["total_invoices"] = status["total_invoices"];
              item["total_payables"] = status["total_payables"];
              item["invoices"] = status["invoices"];
              item["payables"] = status["payables"];
              item["status_notes"] = status["status_notes"];
              item["note"] = status["note"];

              $this
                .closest("tr")
                .find(".btn-action")
                .data("value", item);

              return item;
            } else if (item.placement_id == status["placement_id"] && item.property_id == status["property_id"]) {
              item["id"] = status["id"];
              item["paid_at"] = status["paid_at"];
              item["invoiced_at"] = status["invoiced_at"];
              item["pay_amount"] = status["pay_amount"];
              item["invoice_amount"] = status["invoice_amount"];
              item["prepaid_through"] = formatDate(status["prepaid_through"]);
              item["paid_start_date"] = formatDate(status["paid_start_date"]);
              item["paid_end_date"] = formatDate(status["paid_end_date"]);
              item["paid_notes"] = status["paid_notes"];
              item["invoiced_notes"] = status["invoiced_notes"];
              item["invoiced_start_date"] = formatDate(status["invoiced_start_date"]);
              item["invoiced_end_date"] = formatDate(status["invoiced_end_date"]);
              item["color_code"] = status["color_code"];
              item["insurance_approved_extension_date"] = formatDate(status["insurance_approved_extension_date"]);
              item["total_invoices"] = status["total_invoices"];
              item["total_payables"] = status["total_payables"];
              item["invoices"] = status["invoices"];
              item["payables"] = status["payables"];
              item["note"] = status["note"];

              $this
                .closest("tr")
                .find(".btn-action")
                .data("value", item);

              return item;
            }

            if (item.placement_id == status["placement_id"]) {
              item["status_notes"] = status["status_notes"];
            }

            return item;
          });

          resolve(response);
        },
        error: response => reject(response)
      });
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/status.js